webpackJsonp([162114328119038],{

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/IMG_20171123_175247.ed2d30d6.jpg";

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(96), __esModule: true };

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(97), __esModule: true };

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(91);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(113);
	var $Object = __webpack_require__(10).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(114);
	module.exports = __webpack_require__(10).Object.getPrototypeOf;


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(25);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(24), 'Object', { defineProperty: __webpack_require__(27).f });


/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(52);
	var $getPrototypeOf = __webpack_require__(104);
	
	__webpack_require__(105)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(94);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(95);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(92);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(36);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(93);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(48);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(47);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cache = {};
	
	var Img = function (_Component) {
	  (0, _inherits3.default)(Img, _Component);
	
	  function Img(props) {
	    (0, _classCallCheck3.default)(this, Img);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Img.__proto__ || (0, _getPrototypeOf2.default)(Img)).call(this, props));
	
	    _this.srcToArray = function (src) {
	      return (Array.isArray(src) ? src : [src]).filter(function (x) {
	        return x;
	      });
	    };
	
	    _this.onLoad = function () {
	      cache[_this.sourceList[_this.state.currentIndex]] = true;
	      /* istanbul ignore else */
	      if (_this.i) _this.setState({ isLoaded: true });
	    };
	
	    _this.onError = function () {
	      cache[_this.sourceList[_this.state.currentIndex]] = false;
	      // if the current image has already been destroyed, we are probably no longer mounted
	      // no need to do anything then
	      /* istanbul ignore else */
	      if (!_this.i) return false;
	
	      // before loading the next image, check to see if it was ever loaded in the past
	      for (var nextIndex = _this.state.currentIndex + 1; nextIndex < _this.sourceList.length; nextIndex++) {
	        // get next img
	        var src = _this.sourceList[nextIndex];
	
	        // if we have never seen it, its the one we want to try next
	        if (!(src in cache)) {
	          _this.setState({ currentIndex: nextIndex });
	          break;
	        }
	
	        // if we know it exists, use it!
	        if (cache[src] === true) {
	          _this.setState({ currentIndex: nextIndex, isLoading: false, isLoaded: true });
	          return true;
	        }
	
	        // if we know it doesn't exist, skip it!
	        /* istanbul ignore else */
	        if (cache[src] === false) continue;
	      }
	
	      // currentIndex is zero bases, length is 1 based.
	      // if we have no more sources to try, return - we are done
	      if (nextIndex === _this.sourceList.length) return _this.setState({ isLoading: false });
	
	      // otherwise, try the next img
	      _this.loadImg();
	    };
	
	    _this.loadImg = function () {
	      _this.i = new Image();
	      _this.i.src = _this.sourceList[_this.state.currentIndex];
	
	      if (_this.props.decode && _this.i.decode) {
	        _this.i.decode().then(_this.onLoad).catch(_this.onError);
	      } else {
	        _this.i.onload = _this.onLoad;
	      }
	
	      _this.i.onerror = _this.onError;
	    };
	
	    _this.unloadImg = function () {
	      delete _this.i.onerror;
	      delete _this.i.onload;
	      delete _this.i.src;
	      delete _this.i;
	    };
	
	    _this.sourceList = _this.srcToArray(_this.props.src);
	
	    // check cache to decide at which index to start
	    for (var i = 0; i < _this.sourceList.length; i++) {
	      // if we've never seen this image before, the cache wont help.
	      // no need to look further, just start loading
	      /* istanbul ignore else */
	      if (!(_this.sourceList[i] in cache)) break;
	
	      // if we have loaded this image before, just load it again
	      /* istanbul ignore else */
	      if (cache[_this.sourceList[i]] === true) {
	        var _ret;
	
	        _this.state = { currentIndex: i, isLoading: false, isLoaded: true };
	        return _ret = true, (0, _possibleConstructorReturn3.default)(_this, _ret);
	      }
	    }
	
	    _this.state = _this.sourceList.length
	    // 'normal' opperation: start at 0 and try to load
	    ? { currentIndex: 0, isLoading: true, isLoaded: false
	      // if we dont have any sources, jump directly to unloaded
	    } : { isLoading: false, isLoaded: false };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Img, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // kick off process
	      /* istanbul ignore else */
	      if (this.state.isLoading) this.loadImg();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // ensure that we dont leave any lingering listeners
	      /* istanbul ignore else */
	      if (this.i) this.unloadImg();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var src = this.srcToArray(nextProps.src);
	
	      var srcAdded = src.filter(function (s) {
	        return _this2.sourceList.indexOf(s) === -1;
	      });
	      var srcRemoved = this.sourceList.filter(function (s) {
	        return src.indexOf(s) === -1;
	      });
	
	      // if src prop changed, restart the loading process
	      if (srcAdded.length || srcRemoved.length) {
	        this.sourceList = src;
	
	        // if we dont have any sources, jump directly to unloader
	        if (!src.length) return this.setState({ isLoading: false, isLoaded: false });
	        this.setState({ currentIndex: 0, isLoading: true, isLoaded: false }, this.loadImg);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // if we have loaded, show img
	      if (this.state.isLoaded) {
	        // clear non img props
	        var _props = this.props,
	            src = _props.src,
	            loader = _props.loader,
	            unloader = _props.unloader,
	            decode = _props.decode,
	            rest = (0, _objectWithoutProperties3.default)(_props, ['src', 'loader', 'unloader', 'decode']); //eslint-disable-line
	
	        return _react2.default.createElement('img', (0, _extends3.default)({ src: this.sourceList[this.state.currentIndex] }, rest));
	      }
	
	      // if we are still trying to load, show img and a loader if requested
	      if (!this.state.isLoaded && this.state.isLoading) return this.props.loader ? this.props.loader : null;
	
	      // if we have given up on loading, show a place holder if requested, or nothing
	      /* istanbul ignore else */
	      if (!this.state.isLoaded && !this.state.isLoading) return this.props.unloader ? this.props.unloader : null;
	    }
	  }]);
	  return Img;
	}(_react.Component);
	
	Img.defaultProps = {
	  loader: false,
	  unloader: false,
	  decode: true,
	  src: []
	};
	Img.propTypes =  false ? {
	  loader: _propTypes.node,
	  unloader: _propTypes.node,
	  decode: _propTypes.bool,
	  src: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array])
	} : {};
	exports.default = Img;

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sectionTitle":"src-styles----archive-module---sectionTitle---1gyeo","eventInfo":"src-styles----archive-module---eventInfo---2AlJk","tags":"src-styles----archive-module---tags---12K3r","topic":"src-styles----archive-module---topic---1cWQe","category":"src-styles----archive-module---category---mr_sI","activeCategory":"src-styles----archive-module---activeCategory---2ZyWZ"};

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./vol1/IMG_20171123_175247.jpg": 157
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 88;


/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactImage = __webpack_require__(152);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _board = __webpack_require__(35);
	
	var _board2 = _interopRequireDefault(_board);
	
	var _archiveModule = __webpack_require__(71);
	
	var _archiveModule2 = _interopRequireDefault(_archiveModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Archives = function (_React$Component) {
	  _inherits(Archives, _React$Component);
	
	  function Archives() {
	    _classCallCheck(this, Archives);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Archives.prototype.getArchives = function getArchives() {
	    return this.props.edges.map(function (edge) {
	      return {
	        category: edge.node.frontmatter.category,
	        number: edge.node.frontmatter.number,
	        title: edge.node.frontmatter.title,
	        date: edge.node.frontmatter.date,
	        images: edge.node.frontmatter.images,
	        detailHtml: edge.node.html
	      };
	    });
	  };
	
	  Archives.prototype.render = function render() {
	    var events = this.getArchives();
	    var thisCagegory = this.props.category;
	    var categories = this.props.categories;
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "h2",
	        { className: _archiveModule2.default.sectionTitle },
	        "\u904E\u53BB\u306E\u958B\u50AC\u30A4\u30D9\u30F3\u30C8"
	      ),
	      _react2.default.createElement(
	        "section",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { display: "inline-block", float: "left" } },
	          _react2.default.createElement(
	            "ul",
	            null,
	            categories.map(function (category) {
	              return _react2.default.createElement(
	                "li",
	                { key: category, style: { display: "inline-block", marginRight: "1rem", height: "1rem" } },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/archives/" + category, className: _archiveModule2.default.category, activeClassName: _archiveModule2.default.activeCategory },
	                  category
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement("div", { style: { clear: "both" } })
	      ),
	      _react2.default.createElement(
	        "section",
	        null,
	        function () {
	          if (thisCagegory != "") {
	            return _react2.default.createElement(
	              "h2",
	              null,
	              "#",
	              thisCagegory
	            );
	          }
	        }(),
	        events.map(function (event) {
	          return _react2.default.createElement(Archive, { key: event.number, eventInfo: event });
	        })
	      )
	    );
	  };
	
	  return Archives;
	}(_react2.default.Component);
	
	exports.default = Archives;
	
	var Archive = function (_React$Component2) {
	  _inherits(Archive, _React$Component2);
	
	  function Archive() {
	    _classCallCheck(this, Archive);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  Archive.prototype.render = function render() {
	    var event = this.props.eventInfo;
	    var img_array = event.images.split(',');
	
	    return _react2.default.createElement(
	      "article",
	      null,
	      _react2.default.createElement(
	        _board2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { marginBottom: "-10px" } },
	          _react2.default.createElement(
	            "div",
	            { style: { float: "right", marginRight: "1rem" } },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/archives/" + event.category + "/" },
	              _react2.default.createElement(
	                "p",
	                { className: _archiveModule2.default.tags },
	                "#" + event.category
	              )
	            )
	          )
	        ),
	        _react2.default.createElement("br", { style: { clear: "both" } }),
	        _react2.default.createElement(
	          "div",
	          { className: _archiveModule2.default.eventInfo },
	          _react2.default.createElement(
	            "h3",
	            { className: _archiveModule2.default.topic },
	            "Vol.",
	            event.number,
	            "\u3000",
	            event.title
	          ),
	          _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: event.detailHtml } })
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          function () {
	            var cmpArray = [];
	            img_array.forEach(function (img) {
	              if (img) {
	                var cmp = __webpack_require__(88)("./vol" + event.number + "/" + img.trim());
	                cmpArray.push(_react2.default.createElement(_reactImage2.default, { key: img, src: cmp, width: "70%" }));
	              }
	            });
	            return cmpArray;
	          }()
	        )
	      )
	    );
	  };
	
	  return Archive;
	}(_react2.default.Component);
	
	module.exports = exports["default"];

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _archives = __webpack_require__(90);
	
	var _archives2 = _interopRequireDefault(_archives);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryTemplate = function (_React$Component) {
	  _inherits(CategoryTemplate, _React$Component);
	
	  function CategoryTemplate() {
	    _classCallCheck(this, CategoryTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CategoryTemplate.prototype.render = function render() {
	    var category = this.props.pathContext.category;
	    var categories = this.props.pathContext.categoryArray;
	    var edges = this.props.data.allMarkdownRemark.edges;
	    var siteTitle = this.props.data.site.siteMetadata.title;
	    return _react2.default.createElement(
	      "section",
	      { className: "category-container" },
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: "#" + category + " | " + siteTitle
	      }),
	      _react2.default.createElement(_archives2.default, { edges: edges, category: category, categories: categories })
	    );
	  };
	
	  return CategoryTemplate;
	}(_react2.default.Component);
	
	exports.default = CategoryTemplate;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-category-js-a5b5c7103eaacb8d4550.js